<script setup lang="ts">
// import Icon from '~/components/global/Icon.vue'
import ListBar from '~/components/global/ListBar.vue'
import type { EstateDetailInterface } from '~/types/api/EstateDetail'

const props = defineProps<{
  estateData: EstateDetailInterface
}>()
const { t } = useI18n()

const benefits = [
  props.estateData.benefit1,
  props.estateData.benefit2,
  props.estateData.green_certification
    ? t('pages.estateDetail.benefits.certification', {
        _0: props.estateData.green_certification,
      })
    : null,
  props.estateData.energy_performance_rating
    ? t('pages.estateDetail.benefits.energyPerformanceRating', {
        _0: props.estateData.energy_performance_rating,
      })
    : null,
]

const hasBenefits = benefits.some((benefit) => !!benefit)
</script>

<template>
  <div v-if="hasBenefits" class="c-estate-benefits">
    <ListBar class="c-estate-benefits__list">
      <template v-for="(benefit, index) in benefits" :key="index">
        <li v-if="benefit">
          <div class="c-estate-benefits__content">
            <span class="sc-text">{{ benefit }}</span>
          </div>
        </li>
      </template>
    </ListBar>
  </div>
</template>

<style lang="scss" scoped>
@use '@inkline/inkline/css/mixins' as *;

.c-estate-benefits {
  :deep(.c-estate-benefits__list) {
    --c-list-bar--font-size: 18px;
    --c-list-bar--gap: 32px 40px;
    --c-list-bar--bar-gap: 16px;
    --c-list-bar--bar-width: 32px;
    --c-list-bar--bar-height: 2px;

    display: grid;
    grid-template-columns: repeat(2, auto);
    width: fit-content;

    @include breakpoint-down('sm') {
      --c-list-bar--gap: 18px;
      --c-list-bar--bar-width: 24px;

      grid-template-columns: 1fr;
    }
  }

  &__content {
    display: flex;
    align-items: baseline;
    gap: 4px;

    .sc-text {
      font-weight: 600;
      color: var(--color-primary);
    }

    .sc-popover {
      --popover--width: 300px;

      .ico {
        font-size: 12px;
        color: var(--color-primary);
        top: -1px;
      }
    }
  }
}
</style>
